import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {showExactDate} from "../../../../config/values";
import {ChevronRight,CircleCheck,Circle,CircleX} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";

function OrderAgainButton({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [orderStatus,setOrderStatus] = useState("making");
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/orders/retry-payment`, data, config);
            setSubmitLoading(false);
            if (response.data?.transaction?.id) {
                window.location.replace(`/account/param-pay/${response.data.transaction.id}/${order.id}`);
            } else {
                window.location.replace(`/checkout`);
            }
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <LoadingButton
            className="confirm-btn"
            variant="contained"
            color={"secondary"}
            onClick={() => handleRequest()}
            loading={submitLoading}
        >
            {t("payOrder")}
        </LoadingButton>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(OrderAgainButton));
